import manager from 'app/module46/component-manager.js';
import Swiper from "swiper";
import {Navigation,} from 'swiper/modules';
import Player from '@vimeo/player';

manager.register('product-gallery', component);

/**
 * @param {HTMLDivElement} component
 * @param {Object.<string, HTMLElement>} elements
 * @param {HTMLDivElement[]|HTMLDivElement} elements.thumbArr
 * @param {HTMLImageElement[]|HTMLImageElement} elements.slideArr
 * @param {HTMLTemplateElement} elements.zoomedModal
 * @param {Object.<string, any>} attributes
 * @param {Object.<string, any>} properties
 */
function component(component, elements, attributes, properties) {
	const {
		thumbs,
		zoomedModal
	} = elements;

	let {
		thumbArr,
		slideArr
	} = elements;

	let currSlide = 0;

	if (thumbArr && !Array.isArray(thumbArr)) {
		thumbArr = [thumbArr];
	}

	if (slideArr && !Array.isArray(slideArr)) {
		slideArr = [slideArr];
	}


	const swiper = new Swiper(thumbs, {
		modules:       [Navigation],
		slidesPerView: 2,
		breakpoints:   {
			340: {
				slidesPerView: 3,
				spaceBetween:  10
			},
			450: {
				slidesPerView: 4,
				spaceBetween:  10
			},
			590: {
				slidesPerView: 5,
				spaceBetween:  10
			},
		},
		navigation:    {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
	});


	if (thumbArr && slideArr) {
		for (const thumbEl of thumbArr) {
			thumbEl.addEventListener('mouseenter', () => {
				const slide = thumbEl.dataset.slide;

				const slideEl = component.querySelector(`.slide[data-slide="${slide}"]`);

				if (slideEl.classList.contains('hide')) {
					component.querySelector(`.slide[data-slide="${currSlide}"]`)?.classList.add('hide');

					slideEl.classList.remove('hide');
					currSlide = slide;
				}
			});
		}

		for (const slideEl of slideArr) {
			slideEl.addEventListener('click', () => {
				Swal.fire({
					html:              zoomedModal.innerHTML,
					showConfirmButton: false,
					showCloseButton:   true,
					customClass:       {
						popup: 'zoomed-modal-container'
					},
					willOpen:          (popup) => {
						const vimeoEls = popup.querySelectorAll('[data-vimeo]');
						const players = [];

						vimeoEls.forEach(vimeoEl => {
							const id = vimeoEl.dataset.vimeo;
							players.push(new Player(vimeoEl, {
								id,
								responsive: true
							}));
						});

						const swiperEl = popup.querySelector('.swiper');

						const swiper = new Swiper(swiperEl, {
							modules:       [Navigation],
							slidesPerView: 1,
							autoHeight:    true,
							initialSlide:  currSlide,
							navigation:    {
								nextEl: '.swiper-button-next',
								prevEl: '.swiper-button-prev',
							},
						});

						swiper.on('slideChange', () => {
							for (const player of players) {
								player.pause();
								player.setCurrentTime(0);
							}
						});
					}
				});
			});
		}
	}
}
